import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authApi } from 'api/auth/authApi';
import { IUser } from '../../interfaces/user.interface';
import { HTTP_STATUS_CODES, SSE_STATUS } from 'utils/common-constants';

interface IAuthState {
  isLoggedIn: boolean;
  user: IUser | null;
  connectionStatus: SSE_STATUS | undefined;
  authErrorCode: HTTP_STATUS_CODES | undefined;
}

export const SLICE_KEY = 'auth';

const initialState: IAuthState = {
  isLoggedIn: false,
  user: null,
  connectionStatus: undefined,
  authErrorCode: undefined,
};

const authSlice = createSlice({
  name: SLICE_KEY,
  initialState,
  reducers: {
    setConnectionStatus: (state, { payload }: PayloadAction<SSE_STATUS>) => {
      return {
        ...state,
        connectionStatus: payload,
      };
    },
    setAuthError: (
      state,
      { payload }: PayloadAction<HTTP_STATUS_CODES | undefined>
    ) => {
      return {
        ...state,
        authErrorCode: payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.postLogin.matchFulfilled,
      (state, { payload }: PayloadAction<IUser | any>) => {
        if (payload?.redirect) {
          window.location.assign(payload.redirect);
        } else {
          state.isLoggedIn = true;
          state.user = payload.user;
        }
      }
    );

    builder.addMatcher(authApi.endpoints.postLogin.matchRejected, (state) => {
      const isDev = process.env.NODE_ENV === 'development';
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    });

    builder.addMatcher(
      authApi.endpoints.postLogout.matchFulfilled,
      (state, { payload }: any) => {
        state.isLoggedIn = false;
        state.user = null;
        if (payload?.redirect) {
          window.location.assign(payload.redirect);
        }
      }
    );
  },
});
export const selectUserPermissions = (state: any) =>
  state.auth.user?.userRole?.permissions;
export const selectUserRole = (state: any) =>
  state.auth.user?.userRole?.name ?? '-';
export const selectUserEmail = (state: any) => state.auth.user?.email ?? '-';
export const selectConnectionStatus = (state: any) =>
  state.auth.connectionStatus;
export const selectUserId = (state: any) => state.auth.user?.id;

export const { setConnectionStatus, setAuthError } = authSlice.actions;

export default authSlice.reducer;
